import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import styles from './personalInfo.module.scss';
import utils from '../../utils/utils';
import  { ApiCore } from '../../api/index';
import methods from '../../utils/methods';
import { Button } from 'antd-mobile-v5';
import moment from 'moment';
import { InputItem, Picker, List, DatePicker } from 'antd-mobile';
import {  Toast } from 'antd-mobile';
import provinceData from '../../pagesDoctor/province';
import { jobTitleData } from './jobTitle';

const api = new ApiCore();

const minDate = new Date(Date.now() - 122 * 365 * 24 * 3600 * 1000);
const maxDate = new Date();

function PersonalInfo(props: any) {

    const [isEdit, setIsEdit] = useState(false);
    const [idCardVisible, setIdCardVisible] = useState(false);
    const [personal, setPersonalInfo] = useState<any>({});
    const [personalInput, setPersonalInput] = useState<any>({});
    // 出生日期
    const [birthTime, setBirthTime] = useState<any>('');
    // 省份
    const [province, setProvince] = useState<any>(['']);
    // 城市
    const [city, setCity] = useState<any>(['']);
    // 城市名字
    const [cityData, setCityData] = useState<any>([]);
    // 职称
    const [jobTitle, setJobTitle] = useState<any>(['']);

    useEffect(() => {
        document.title = '个人信息';
        initData();
    }, [])

    // 初始化数据
    const initData = () => {
        setCityData(provinceData[0].children);
        api.GetPersonalInfo().then((res: any) => {
            if (res.code == '0') {
                const _data = res.data || {};
                _data && setPersonalInfo(_data);
                _data.birthTime && setBirthTime(new Date(_data.birthTime));
            }
        });
    }

    // 修改信息
    const updateInfo= () => {
        personal.province && setProvince([personal.province]);
        personal.city && setCity([personal.city]);
        personal.jobTitle && setJobTitle([personal.jobTitle]);
        const item: any = provinceData.find(val => val.value === personal.province);
        (item && item.children) && setCityData(item.children);
        // 默认编辑
        setPersonalInput(personal);
        setIsEdit(true);
    }

    // 退出修改信息
    const exitUpdateInfo= () => {
        setIsEdit(false);
    }

    // 保存修改信息
    const saveUpdateInfo= () => {
        let idCard = personalInput.idCard;
        if (idCard) {
            if (idCard.length < 15 || idCard.length > 18) {
                // Toast.fail('身份证位数不正确', 0.8);
                Toast.fail('请输入正确的身份证号', 0.8);
                return
            }
    
            if (methods.isCardNo(idCard) === false) {
                // Toast.fail('身份证输入不合法', 0.8);
                Toast.fail('请输入正确的身份证号', 0.8);
                return
            }
        }
        let _birthTime = birthTime ? moment(birthTime).format('YYYY-MM-DD') : '';
        let _personalInput = {
            ...personalInput,
            province: province[0],
            city: city[0],
            jobTitle: jobTitle[0],
            birthTime: _birthTime
        }
        api.UpdatePersonalInfo(_personalInput).then((res: any) => {
            if (res.code == 0) {
                let token = sessionStorage.getItem('token');
                if (token) {
                    // 每次保存更新用户姓名
                    let mToken = JSON.parse(token);
                    mToken.userName = personalInput.name;
                    sessionStorage.setItem('token', JSON.stringify(mToken));
                    localStorage.setItem('token', JSON.stringify(mToken));
                }
                setPersonalInfo(_personalInput);
                Toast.success('信息保存成功', 0.8);
            }
            setIsEdit(false);
        })
    }

    // 数据绑定
    const inputOnChange = (val: any, type: string) => {
        if (type === 'name') {
            setPersonalInput({
                ...personalInput,
                name: val
            });
        } else if (type === 'birthTime') {
            setPersonalInput({
                ...personalInput,
                birthTime: val
            });
        } else if (type === 'idCard') {
            setPersonalInput({
                ...personalInput,
                idCard: val
            });
        } else if (type === 'province') {
            setPersonalInput({
                ...personalInput,
                province: val
            });
        } else if (type === 'city') {
            setPersonalInput({
                ...personalInput,
                city: val
            });
        } else if (type === 'hospital') {
            setPersonalInput({
                ...personalInput,
                hospital: val
            });
        } else if (type === 'dept') {
            setPersonalInput({
                ...personalInput,
                dept: val
            });
        } else if (type === 'jobTitle') {
            setPersonalInput({
                ...personalInput,
                jobTitle: val
            }); 
        }
    }

    // 省份
    const onProvince = (value: any) => {
        setProvince(value);
        const item: any = provinceData.find(val => val.value === value[0]);
        (item && item.children) && setCityData(item.children);
        // 重置所选城市
        setCity([''])
    }

    // 城市
    const onCity =  (value: any) => {
        setCity(value);
    }

    // 科室
    const onJobTitle =  (value: any) => {
        setJobTitle(value);
    }

    // 日历
    const onDate = (value: any) => {
        setBirthTime(value);
    }

    return (
        <div className={`${styles.personalInfo_content}`}>
            <div className={`${styles.personal_title}`}>身份信息</div>
            <div className={`${styles.personal_content}`}>
                <div className={`${styles.item_with_line}`}> 
                    <div className={`${styles.item_title}`}>姓名</div>
                    {
                        !isEdit ?
                        <div className={`${styles.item_info}`}>{personal.name || '暂未填写'}</div>
                        :
                        <InputItem type='text' autoFocus={true} value={ personalInput.name } onChange={(val) => { inputOnChange(val, 'name') }} />
                    }
                </div>
                <div className={`${styles.item_with_line}`}> 
                    <div className={`${styles.item_title}`}>出生日期</div>
                    {
                        !isEdit ?
                        <div className={`${styles.item_info}`}>{personal.birthTime || '暂未选择'}</div>
                        :
                        <DatePicker
                            mode="date"
                            title=""
                            minDate={minDate}
                            maxDate={maxDate}
                            value={birthTime}
                            extra="请选择"
                            onChange={(date: any) => onDate(date)}
                        >
                            <List.Item
                                arrow={'horizontal'}
                            >
                            </List.Item>
                        </DatePicker>
                    }
                </div>
                <div className={`${styles.item_with_line}`} onClick = { () => { setIdCardVisible(!idCardVisible); }}> 
                    <div className={`${styles.item_title}`}>身份证号</div>
                    {
                        !isEdit ?
                        <div className={`${styles.item_info}`}>{ !idCardVisible ? (personal.idCard ? personal.idCard.substr(0, 4) + "**********" + personal.idCard.substr(personal.idCard.length - 4) : '暂未填写') : ( personal.idCard || '暂未填写') }</div>
                        :
                        <InputItem type='text' value={ personalInput.idCard }  onChange={(val) => { inputOnChange(val, 'idCard') }} />
                    }
                </div>
                <div className={`${styles.item_with_line}`}> 
                    <div className={`${styles.item_title}`}>省份</div>
                    {
                        !isEdit ?
                        <div className={`${styles.item_info}`}>{personal.province || '暂未选择'}</div>
                        :
                        <Picker
                            data={provinceData}
                            cols={1}
                            className={`${styles.picker}`}
                            value={province}
                            extra={'请选择'}
                            onChange={(v: any) => onProvince(v)}
                        >
                            <List.Item
                                arrow={'horizontal'}
                            ></List.Item>
                        </Picker>
                    }
                </div>
                <div className={`${styles.item_no_line}`}> 
                    <div className={`${styles.item_title}`}>城市</div>
                    {
                        !isEdit ?
                        <div className={`${styles.item_info}`}>{personal.city || '暂未选择'}</div>
                        :
                        <Picker
                            data={cityData}
                            cols={1}
                            className={`${styles.picker}`}
                            value={city}
                            extra={'请选择'}
                            onChange={(v: any) => onCity(v)}
                        >
                            <List.Item
                                arrow={'horizontal'}
                            ></List.Item>
                        </Picker>
                    }
                </div>
            </div>
            <div className={`${styles.personal_title}`}>职业信息</div>
            <div className={`${styles.personal_content}`}>
                <div className={`${styles.item_with_line}`}> 
                    <div className={`${styles.item_title}`}>所在医疗机构</div>
                    {
                        !isEdit ?
                        <div className={`${styles.item_info}`}>{personal.hospital || '暂未填写'}</div>
                        :
                        <InputItem type='text' value={ personalInput.hospital } onChange={(val) => { inputOnChange(val, 'hospital') }} />
                    }
                </div>
                <div className={`${styles.item_with_line}`}> 
                    <div className={`${styles.item_title}`}>所在科室</div>
                    {
                        !isEdit ?
                        <div className={`${styles.item_info}`}>{personal.dept || '暂未填写'}</div>
                        :
                        <InputItem type='text' value={ personalInput.dept } onChange={(val) => { inputOnChange(val, 'dept') }} />
                    }
                </div>
                <div className={`${styles.item_no_line}`}> 
                    <div className={`${styles.item_title}`}>职称</div>
                    {
                        !isEdit ?
                        <div className={`${styles.item_info}`}>{personal.jobTitle || '暂未选择'}</div>
                        :
                        <Picker
                            data={jobTitleData}
                            cols={1}
                            className={`${styles.picker}`}
                            value={jobTitle}
                            extra={'请选择'}
                            onChange={(v: any) => onJobTitle(v)}
                        >
                            <List.Item
                                arrow={'horizontal'}
                            ></List.Item>
                        </Picker>
                    }
                </div>
            </div>
            {
                !isEdit ?
                <div className={`${styles.btn_wrap}`}>
                    <Button className={`${styles.update_btn}`} color='primary' onClick={() => { updateInfo() }}>修改信息</Button>
                </div>
                :
                <div className={`${styles.btn_wrap}`}>
                    <Button className={`${styles.update_btn}`} color='primary' fill='outline' onClick={() => { exitUpdateInfo() }}>不保存，退出修改</Button>
                    <Button className={`${styles.update_btn}`} color='primary' onClick={() => { saveUpdateInfo() }}>保存信息</Button>
                </div>
            }
            <div className={`${styles.personal_tip}`}>
                为了保障您的账户安全，此信息只作为医生工作室中个人资料数据。修改信息不会修改已报名活动所提交的个人信息和银行卡信息，感谢您的理解。
            </div>
        </div>
    )

}

export default PersonalInfo;